import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-b2bteams',
  templateUrl: './b2bteams.component.html',
  styleUrls: ['./b2bteams.component.scss']
})
export class B2bteamsComponent implements OnInit {

  b2bteamsForm: FormGroup;
  public submitted: boolean = false;
  private isFormSubmit: boolean = false;
  public value: number = 0;
  public pricePerPerson: number = 10;
  public total = 0;
  public errorMsg = "";
  public isUsersValid = false;
  constructor(private formBuilder: FormBuilder, private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.b2bteamsForm = this.formBuilder.group({
      users: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      company_name: ['', [Validators.required]],
      couponCode: ['', Validators.required]
    });
  }

  get b() { return this.b2bteamsForm.controls; }

  submit() {
    this.submitted = true;
    if (this.b2bteamsForm.invalid || !this.isFormSubmit) {
      return;
    }
    this.sendTeamsData(this.b2bteamsForm.value);
  }

  sendTeamsData(val) {
    val['qty'] = this.value;
    let url = "billingservice/coupon/front/create";
    this.apiService.postbillData(url, val).subscribe(res => {
      if (res['status']) {
        window.location.href = res.url;
      } else {
        this.errorMsg = res.message;
        setTimeout(() => {
          this.errorMsg = "";
        }, 2000);
      }
    });
  }

  getPeople(event) {
    this.value = parseInt(event.target.value > 0 ? event.target.value : 0);
    if (this.value >= 5 && this.value <= 100) {
      this.isUsersValid = false;
      this.total = this.value * this.pricePerPerson;
    } else {
      this.isUsersValid = true;
      this.total = this.value * this.pricePerPerson;
    }
  }

  public corporateCouponCheck(event) {
    const input = event.target as HTMLInputElement;
    this.b2bteamsForm.controls['couponCode'].setValue(input.value.toUpperCase(), { emitEvent: false });
    let couponCode = event.target.value ? event.target.value : "invalid"
    let url = 'billingservice/coupon/get/coupon-info/' + couponCode;
    this.apiService.getDatabill(url).subscribe((response: [any]) => {
      if (response && response.length > 0) {
        this.isFormSubmit = false;
      } else {
        this.isFormSubmit = true;
      }
    });
  }

}
